import {types} from './types';

const initialState = {
    shift: {
        data: [],
        countPage: 0
    }
}

export function cashiersShiftReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_SHIFT:
            return { ...state, shift: action.payload};
        default:
            return state
    }
}